import { AxiosError } from 'axios';

const getNonEmptyString = (value: unknown): string | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined;

export const getAxiosErrorMessage = (error: unknown): string => {
  const axiosError = error as AxiosError<{
    data?: string;
    errors?: { detail?: string }[];
    message?: string;
    error?: string;
  }>;
  const responseData = axiosError.response?.data;

  return (
    // json api errors
    getNonEmptyString(responseData?.errors?.[0]?.detail) ||
    // everest legacy errors
    getNonEmptyString(responseData?.data) ||
    // fallbacks for non-standard response error messages
    getNonEmptyString(responseData?.message) ||
    getNonEmptyString(responseData?.error) ||
    getNonEmptyString(axiosError.message) ||
    'An unexpected error occurred'
  );
};
